<template>
	<v-form v-if="!place.services.length || place" @submit.prevent="submit">
		<v-row>
			<v-col cols="12" class="text-left">
				<span class=" ma-2 headline text--secondary">
					Detalle del servicio prestado
				</span>
			</v-col>
			<v-col cols="12" class="py-0">
				<v-switch
					v-model="usePrice"
					color="primary"
					class="mt-0 pt-0"
					label="¿Su servicio tiene un precio diario o por unidad?"
				></v-switch>
			</v-col>
			<v-col cols="12" sm="4" md="5" lg="5">
				<v-text-field
					v-model.trim="$v.formData.name.$model"
					outlined
					dense
					filled
					label="Nombre"
					hint="Ej: Alimentación"
					:disabled="loading"
					:error-messages="nameErrors"
					@input="$v.formData.name.$touch()"
					@blur="$v.formData.name.$touch()"
				></v-text-field>
			</v-col>
			<v-col cols="12" sm="4" md="4" lg="5">
				<v-text-field
					v-model="$v.formData.price.$model"
					type="number"
					outlined
					dense
					filled
					:disabled="!usePrice || loading"
					label="Precio"
					hint="Ej: 5600"
					:error-messages="priceErrors"
					@input="$v.formData.price.$touch()"
					@blur="$v.formData.price.$touch()"
				></v-text-field>
			</v-col>
			<v-col cols="12" sm="4" md="3" lg="2">
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-btn
							block
							class="mt-1"
							small
							:loading="loading"
							color="success"
							type="submit"
							v-on="on"
						>
							<v-icon>mdi-content-save-outline</v-icon>
							Guardar
						</v-btn>
					</template>
					Guardar servicio
				</v-tooltip>
			</v-col>
		</v-row>
	</v-form>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { minLength, maxLength, required } from 'vuelidate/lib/validators';
import { mapActions, mapMutations } from 'vuex';

export default {
	name: 'ServiceForm',
	mixins: [validationMixin],
	props: {
		place: {
			type: Object,
			default: () => null,
		},
	},
	data() {
		return {
			usePrice: true,
			formData: { name: '', price: '' },
			loading: false,
		};
	},
	computed: {
		nameErrors() {
			const errors = [];
			if (!this.$v.formData.name.$dirty) return errors;
			!this.$v.formData.name.required && errors.push('Campo requerido');
			!this.$v.formData.name.minLength && errors.push('Minimo 3 Caracteres');
			!this.$v.formData.name.maxLength && errors.push('Maximo 50 Caracteres');
			return errors;
		},
		priceErrors() {
			const errors = [];
			if (!this.$v.formData.price.$dirty) return errors;
			!this.$v.formData.price.required && errors.push('Campo requerido');
			this.formData.price.toString().includes('.') &&
				errors.push('No debe llevar puntos o coma');
			this.formData.price.toString().includes(',') &&
				errors.push('No debe llevar puntos o coma');
			return errors;
		},
	},
	validations: {
		formData: {
			name: {
				required,
				minLength: minLength(3),
				maxLength: maxLength(50),
			},
			price: {
				required,
			},
		},
	},
	mounted() {
		if (this.place.services.length) this.formData = { ...this.place.services[0] };
	},
	watch: {
		usePrice(val) {
			if (!val) this.formData.price = '0';
		},
		place: {
			deep: true,
			handler(newVal) {
				newVal && newVal.services.length
					? (this.formData = { ...newVal.services[0] })
					: (this.formData = { name: '', price: '' });
			},
		},
	},
	methods: {
		async submit() {
			this.$v.$touch();
			if (
				!this.$v.$invalid &&
				(!this.formData.price.includes('.') || this.formData.price.includes(','))
			) {
				this.loading = true;
				if (this.place.services.length) {
					await this.updateService({
						payload: this.formData,
						placeId: this.place._id,
					});
					this.loading = false;
				} else {
					await this.createService({
						payload: this.formData,
						placeId: this.place._id,
					});
					this.loading = false;
				}
			}
		},
		...mapActions({
			createService: 'Place/createService',
			updateService: 'Place/updateService',
		}),
		...mapMutations({ snackbar: 'Snackbar/showMessage' }),
	},
};
</script>

<style scoped></style>
